module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notFound"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": _vm.logo,
      "alt": "Boleto Web"
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('h1', [_vm._v("Ops! Você se perdeu! ")]), _vm._v(" "), _c('h4', [_vm._v("Esta página não existe.")]), _vm._v(" "), _c('router-link', {
    staticClass: "vertical-5p lead",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Voltar para o início.")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9eedfe6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = 410
// module chunks = 1